import { Alert } from "@mui/material";

interface IStepRestrictionProps {
  blockedDays: number;
}

export const StepRestriction: React.FC<IStepRestrictionProps> = (props: IStepRestrictionProps) => {
    return (
      <Alert severity="error">{`Die nächste elektronische Buchung ist erst wieder in ${props.blockedDays} Tagen möglich.
        Sollte in den Häusern momentaner Leerstand bestehen, bitte direkt telefonisch oder per E-Mail beim Hüttenwart buchen.`}</Alert>
    );
  };